import angular from 'angular';
import activityIcon from './activityIcon';

export default angular
  .module('components.activityIcon', [])
  .component('activityIcon', activityIcon).name;
